

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 22"}, rest), [h('path', {"fill":"currentColor","fill-rule":"evenodd","d":"M9 2.85c.08.41-.18.8-.58.89-4.39.9-7.27 5.1-6.54 9.57.56 3.46 3.37 6.27 6.83 6.83 4.49.72 8.68-2.17 9.57-6.58a.75.75 0 1 1 1.47.29 9.852 9.852 0 0 1-9.68 7.9c-.53 0-1.07-.04-1.61-.13-4.09-.66-7.42-3.98-8.08-8.07C-.47 8.29 2.92 3.33 8.11 2.27c.41-.08.8.18.89.58Zm6.49-1.61c2.48.72 4.55 2.79 5.27 5.27.55 1.88.5 3.17-.16 4.05-.8 1.07-2.26 1.19-3.28 1.19H14c-2.49 0-3.75-1.41-3.75-4.2V4.68c0-1.02.12-2.48 1.18-3.28.89-.66 2.17-.71 4.06-.16Zm-2.21 1.12c-.41 0-.73.08-.94.24-.39.29-.58.97-.58 2.08v2.88c0 2.24.86 2.7 2.25 2.7h3.32c1.1 0 1.78-.19 2.08-.58.35-.46.32-1.38-.07-2.73-.58-1.97-2.28-3.68-4.25-4.25-.74-.23-1.34-.34-1.81-.34Z"}, [])]);
};

        